import { ActionTree } from 'vuex';
import { NFCState } from '@/modules/Administrative/store/state';
import { RootState } from '@/plugins/store';
import { NFCActions, NFCActionTypes } from '@/modules/Administrative/store/action-types';
import NFCService, { FilterNFC, HistoriqueNFC } from '@/modules/Administrative/services/NFCService';
import { NFC } from '@/modules/Administrative/store/mutation-types';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import ErrorManager from '@/common/utils/ErrorManager';

export const actions: ActionTree<NFCState, RootState> = {
    async [NFCActions.GET_NFC]({commit}: NFCActionTypes, payload: FilterNFC) {
        commit(NFC.SET_ERROR, undefined);
        commit(NFC.SET_IS_LOADING, true);
        commit(NFC.SET_PAGE, payload.page);
        try {
            const response = await NFCService.getNFC(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(NFC.SET_ITEMS, response.data);
                    commit(NFC.SET_SCROLL, 0);
                    commit(NFC.SET_NB_OF_PAGES, response.headers.pages);
                    commit(NFC.SET_COUNT, response.headers.count);
                } else {
                    commit(NFC.ADD_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(NFC.SET_IS_LOADING, false);

        } catch (error) {
            commit(NFC.SET_IS_LOADING, false);
            commit(NFC.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [NFCActions.GET_HISTORIQUE_NFC]({commit}: NFCActionTypes, payload: HistoriqueNFC) {
        commit(NFC.SET_ERROR, undefined);
        commit(NFC.SET_HISTORIQUE_IS_LOADING, true);
        commit(NFC.SET_NUMERO_NFC, payload.numeroNFC);
        commit(NFC.SET_HISTORIQUE_PAGE, payload.pageable?.page);
        try {
            const response = await NFCService.getHistoriqueNFC(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.pageable?.page === 0) {
                    commit(NFC.SET_HISTORIQUE, response.data);
                    commit(NFC.SET_HISTORIQUE_SCROLL, 0);
                    commit(NFC.SET_NB_OF_HISTORIQUE_PAGES, response.headers.pages);
                } else {
                    commit(NFC.ADD_HISTORIQUE, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(NFC.SET_HISTORIQUE_IS_LOADING, false);

        } catch (error) {
            commit(NFC.SET_HISTORIQUE_IS_LOADING, false);
            commit(NFC.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [NFCActions.GET_XLS_NFC]({ commit }: NFCActionTypes, payload: FilterNFC) {
        commit(NFC.SET_IS_LOADING, true);
        try {
            const response = await NFCService.getExportXlsNFC(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data],{ type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_nfc.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(NFC.SET_EXPORT_XLS_IS_LOADING, false);
        } catch (error) {
            commit(NFC.SET_EXPORT_XLS_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    }
};
